"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const MediaPreview_module_scss_1 = __importDefault(require("./MediaPreview.module.scss"));
const react_i18next_1 = require("react-i18next");
const MediaPreview = (props) => {
    var _a;
    const [imageAvailable, setImageAvailable] = (0, react_1.useState)(true);
    const { t } = (0, react_i18next_1.useTranslation)();
    const mediaItem = props.mediaItem
        ? Object.assign({}, props.mediaItem) : { mediatype: "empty" };
    // Catch case where older items do not have a mediaItem set
    if (mediaItem) {
        const fileType = mediaItem.filetype;
        if (fileType === "jpeg" ||
            fileType === "png" ||
            fileType === "jpegOrPng" ||
            fileType === "jpg") {
            // JPG is a legacy option
            mediaItem.mediatype = "photo";
        }
    }
    let mediaContent;
    switch ((mediaItem === null || mediaItem === void 0 ? void 0 : mediaItem.mediatype) || "empty") {
        case "photo":
            mediaContent = (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("img", { className: [
                        "media",
                        !imageAvailable || !mediaItem.hlink ? "isHidden" : null,
                    ].join(" "), src: mediaItem.hlink, alt: (_a = mediaItem.title) === null || _a === void 0 ? void 0 : _a.label, onError: (e) => {
                        setImageAvailable(false);
                    } }),
                react_1.default.createElement("div", { className: [
                        MediaPreview_module_scss_1.default.errorDisplay,
                        !(!imageAvailable || !mediaItem.hlink) ? "isHidden" : null,
                    ].join(" ") }, t("form.imageNotAvailable"))));
            break;
        case "video":
            if (mediaItem.filetype === "youtube") {
                mediaContent = (react_1.default.createElement("iframe", { title: "Youtube Video", width: "100%", height: "auto", src: `https://www.youtube-nocookie.com/embed/${mediaItem.filename}`, frameBorder: "0", allow: "autoplay; fullscreen", allowFullScreen: true }));
            }
            else if (mediaItem.filetype === "vimeo") {
                mediaContent = (react_1.default.createElement("iframe", { title: "Vimeo Video", src: `https://player.vimeo.com/video/${mediaItem.filename}`, width: "100%", height: "auto", frameBorder: "0", allow: "autoplay; fullscreen", allowFullScreen: true }));
            }
            else {
                mediaContent = (react_1.default.createElement("div", { className: MediaPreview_module_scss_1.default.errorDisplay },
                    t("form.unknownMediaType"),
                    ": ",
                    mediaItem.mediatype,
                    " /",
                    " ",
                    mediaItem.filetype));
            }
            break;
        case "empty":
            mediaContent = (react_1.default.createElement("div", { className: MediaPreview_module_scss_1.default.errorDisplay }, t("form.noMediaAvailable")));
            break;
        default:
            mediaContent = (react_1.default.createElement("div", { className: MediaPreview_module_scss_1.default.errorDisplay },
                t("form.unknownMediaType"),
                ": ",
                mediaItem.mediatype,
                " /",
                " ",
                mediaItem.filetype));
    }
    return (react_1.default.createElement("div", { className: `${MediaPreview_module_scss_1.default.MediaPreview} ${props.coverView ? MediaPreview_module_scss_1.default.coverView : ""}` }, mediaContent));
};
exports.default = MediaPreview;
//# sourceMappingURL=MediaPreview.js.map